<template>
  <div>
    <ButtonCallToAction
      v-bind="$attrs"
      :enable-button="enableButton"
      bottom-sheet-class="tw-px-0"
      :bottom-sheet-title="`${$t('global.contact')}`"
      :bottom-sheet-compute-action-class="computeActionClass"
      :button-class="`${buttonClass} tw-shadow-sm`"
      title-class="tw-text-dt-button"
      :hide-social-title="hideSocialTitle"
      :show-footer="showFooter"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  enableButton: CallToActionButton
  buttonClass?: string
  hideSocialTitle?: boolean
  showFooter?: boolean
}>()

const websiteInfoStore = useWebsiteInfoStore()
const computeActionClass = (platform: ProductCallToAction): string => {
  return `tw-m-2 tw-border-${platform.variant} tw-border tw-rounded-lg tw-text-${platform.variant}`
}

</script>

<style scoped>
:deep(.cta-footer) {
  border-top: none !important;
  box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.08) !important;
}
</style>
